import { bookingInquiryStrings, bookingInquiryTradeConditionStrings } from '@data/bookingInquiry';
import { tradeCondtion } from '@models/BookingInquiry';

export const bookingInquiryStatusOptions = [
  { value: '未対応' as const, label: '未対応' },
  { value: '対応中' as const, label: '対応中' },
  { value: undefined, label: 'ALL' },
];

export const adminBookingInquiryTradeConditionOptions = tradeCondtion.types
  .map((literal) =>
    [true, false].map((hasPickups) => ({
      label: `${bookingInquiryTradeConditionStrings[literal.value]} (${
        hasPickups ? bookingInquiryStrings.needsPickup : bookingInquiryStrings.noPickup
      })`,
      value: `${bookingInquiryTradeConditionStrings[literal.value]} (${
        hasPickups ? bookingInquiryStrings.needsPickup : bookingInquiryStrings.noPickup
      })`,
    })),
  )
  .flat();

export const adminBookingInquiryTradeCondtionFilters = new Map(
  tradeCondtion.types
    .map((literal) =>
      [true, false].map(
        (hasPickups) =>
          [
            `${bookingInquiryTradeConditionStrings[literal.value]} (${
              hasPickups ? bookingInquiryStrings.needsPickup : bookingInquiryStrings.noPickup
            })` as string,
            {
              trade_condition: literal.value,
              has_pickups: hasPickups,
            },
          ] as const,
      ),
    )
    .flat(),
);
